import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F8858SchdC1Service {

  constructor(private http: HttpClient) { }

  saveF8858ScheduleC1(
    baseUrl: string,
    scheduleSettings: any[],
    scheduleC1Details: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    // Use the correct endpoint with action_code (from original AngularJS service)
    const url = `${baseUrl}/saveJsonObject?action_code=jrj82n`;

    // Build checkLockedbj like in original AngularJS using rowData (SuperPrompt V8)
    const checkLockedbj: any[] = [];
    checkLockedbj.push({
      "leid": rowData.LEID || rowData.PARENT_LEID,
      "cdr_number": rowData.CDR_NO || rowData.PARENT_CDR_NO,
      "consol_group_key": String(rowData.CONSOL_GROUP_KEY || ''),
      "reporting_period": String(rowData.REPORTING_PERIOD || ''),
      "combination_key": String(rowData.COMBINATION_KEY || ''),
      "scenario_key": parseInt(filterParams.scenario || globalService?.globalParams?.scenario || 74)
    });

    // Build payload structure exactly like in original AngularJS (SuperPrompt V8)
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    // Add jsonObj and jsonSettings like original AngularJS service
    const jsonSettings = JSON.stringify(scheduleSettings);
    const jsonObj = JSON.stringify(scheduleC1Details);
    
    params = _.extend({ jsonObj: jsonObj }, params);
    params = _.extend({ jsonSettings: jsonSettings }, params);
    params.process_name = 'F8858_Schedule_C1_Save';
    
    // Add checkLockedbj
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // Add essential parameters with fallbacks (SuperPrompt V8)
    params.tax_year = filterParams.tax_year || params.tax_year || rowData.TAX_YEAR;
    params.scenario = filterParams.scenario || params.scenario || rowData.SCENARIO;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || rowData.JCD_KEY || 250;

    // Add scenarioCode and is_issue_key_enabled
    if (!params.scenarioCode) {
      params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || 'RAF';
    }
    
    if (!params.is_issue_key_enabled) {
      params.is_issue_key_enabled = 'N';
    }

    // Convert params to URLSearchParams for form-urlencoded format (SuperPrompt V8)
    const formData = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        formData.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.http.post<any>(url, formData.toString(), httpOptions);
  }
}

